import type { Tour } from '@carboncopyco/types';
import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { TrackEventTourNames } from '../types';

type EventName = keyof typeof TrackEventTourNames;
type FunctionName =
  `track${Capitalize<CamelCase<keyof typeof TrackEventTourNames>>}`;
const functionNameEntries = Object.keys(TrackEventTourNames).map(
  (eventName) => [
    eventName as EventName,
    `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}` as FunctionName,
  ]
);

export const useTourAnalytics = ({
  location,
  tourId,
}: {
  location: string;
  tourId?: Tour['id'];
}) => {
  const { trackEvent } = useAnalytics();

  return Object.fromEntries(
    functionNameEntries.map(([eventName, functionName]) => [
      functionName,
      (payload?: TrackEventProperties) => {
        trackEvent(TrackEventTourNames[eventName], {
          ...payload,
          tourId,
          location,
        });
      },
    ])
  ) as {
    [K in FunctionName]: (payload?: Record<string, any>) => void;
  };
};
